"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDownOptionType = void 0;
/**
 * SharePoint property pane drop down option type.
 */
var DropDownOptionType;
(function (DropDownOptionType) {
    /**
     * Render a normal option.
     */
    DropDownOptionType[DropDownOptionType["Normal"] = 0] = "Normal";
    /**
     * Render a divider.
     */
    DropDownOptionType[DropDownOptionType["Divider"] = 1] = "Divider";
    /**
     * Render a header.
     */
    DropDownOptionType[DropDownOptionType["Header"] = 2] = "Header";
})(DropDownOptionType = exports.DropDownOptionType || (exports.DropDownOptionType = {}));
//# sourceMappingURL=propertyPaneDropDownOption.js.map